export class WebAppInfo {
 public readonly appVersion = "1.5.29 (2)";

}
